module.exports = "/assets/f82f566b9fa90aa4a8e1b502f65023a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/I7.png
// module id = 1464
// module chunks = 0